export const CART_DISCOUNT_THRESHOLD_COUNT = 1
